// Mock data for Ortiz Truck & Landscaping LLC clone

export const companyInfo = {
  name: "Ortiz Truck & Landscaping LLC",
  tagline: "MAGIC VALLEY HAULING",
  phone: "(208) 490-7614",
  email: "ortiztruckandlandscapingllcort@gmail.com",
  location: "Magic Valley & Surrounding Areas, Idaho",
  hours: "Mon-Sat: 7:00 AM - 6:00 PM",
};

export const socialLinks = {
  facebook:
    "https://www.facebook.com/share/1937ydXCgN/?mibextid=wwXIfr",
  instagram:
    "https://www.instagram.com/ortiztrucklandscaping?stkn=c3MxdW40MWlwcG1j&utm_source=qr",
  tiktok:
    "https://www.tiktok.com/@ortiz.truck_landscaping?_r=1&_t=ZP-99W5nOMgZmZ",
};

export const navLinks = [
  { label: "SERVICES", href: "#services" },
  { label: "MATERIALS", href: "#gallery" },
  { label: "ABOUT US", href: "#about" },
  { label: "REVIEWS", href: "#reviews" },
];

export const services = [
  {
    id: "delivery",
    tag: "delivery",
    title: "Material Delivery",
    description:
      "Gravel, topsoil, sand, and decorative rock delivered directly to your job site.",
    image:
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_magic-valley-truck/artifacts/iw3lwnq6_IMG_2452%20%281%29.webp",
    capabilities: [
      "Road Base",
      "Decorative Rock",
      "Quality Sand",
      "And Much More",
    ],
  },
  {
    id: "debris",
    tag: "debris",
    title: "Debris Removal",
    description:
      "Fast, efficient hauling of construction, landscaping, and demolition debris.",
    image:
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_magic-valley-truck/artifacts/412oe7vb_IMG_1936.webp",
    capabilities: [
      "Concrete & dirt haul-away",
      "Excavation clearing",
      "Remodeling debris haul-offs",
    ],
  },
  {
    id: "hauling",
    tag: "hauling",
    title: "Contract Hauling",
    description:
      "Commercial and residential bulk transport services with our heavy equipment.",
    image:
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_magic-valley-truck/artifacts/x4dhgjj3_IMG_1819.webp",
    rotate: 90,
    capabilities: [
      "Hourly rates available",
      "Belly Dump Operator",
      "Dump Truck Operator",
    ],
  },
];

export const materials = [
  {
    id: 1,
    title: "Gray 3/4 A",
    category: "Material Delivery",
    description:
      "Decorative gravel that adds texture and natural beauty to any landscape. Perfect for flower beds, accent areas, and low-maintenance landscaping. Provides excellent drainage and a long-lasting, professional appearance.",
    image:
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_magic-valley-truck/artifacts/6bfthbdm_IMG_2135.webp",
  },
  {
    id: 2,
    title: "Pea Gravel",
    category: "Material Delivery",
    description:
      "Smooth, rounded gravel in natural earth tones. Perfect for walkways, drainage areas, playgrounds, and landscape accents. Provides excellent drainage while adding a clean, attractive finish to any outdoor space.",
    image:
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_magic-valley-truck/artifacts/6v4xancy_IMG_2158.webp",
  },
  {
    id: 3,
    title: '"A" Rock',
    category: "Material Delivery",
    description:
      'Decorative gravel with natural color variation and texture. Similar in size to 3/4" Gray Lava Rock but with a distinct look and stone type. Perfect for flower beds, accent areas, and low-maintenance landscapes.',
    image:
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_magic-valley-truck/artifacts/4gevl7as_Clean%20Glendale%20Sth%20Hills.webp",
  },
  {
    id: 4,
    title: "Mountain Quartz",
    category: "Material Delivery",
    description:
      "A beautiful decorative landscape rock with natural gold and white quartz tones. Perfect for flower beds, accent areas, and low-maintenance landscapes. Adds a clean, modern look while providing long-lasting durability.",
    image:
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_magic-valley-truck/artifacts/bxhszzg5_3.4%20Mountain%20Quartz.webp",
  },
  {
    id: 5,
    title: "Road Base",
    category: "Material Delivery",
    description:
      "A durable, compactable material used for driveways, roads, parking areas, and foundation preparation. Available in gray and brown color options from multiple pits. Provides a strong, stable base with excellent compaction and long-lasting performance.",
    image:
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_magic-valley-truck/artifacts/03odarww_3.4%20RB%20Gale%20Lim.webp",
  },
  {
    id: 6,
    title: "Fine Masonry Sand",
    category: "Material Delivery",
    description:
      "Clean sifted masonry grade sand, perfect for sandbox bedding, pool liners, and pavers.",
    image:
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_magic-valley-truck/artifacts/j1enhsky_IMG_1934.webp",
  },
];

export const reviews = [
  {
    id: 1,
    name: "Brian Faulconer",
    initial: "B",
    location: "Magic Valley, ID",
    project: "Gravel & Compost",
    date: "5/26/26",
    rating: 5,
    text: "Miguel is AWESOME! He is extremely professional and great to deal with. This is the only place I will use for my gravel, compost, or other related needs. Fair and reliable, very important for me when doing business. Thank you Miguel!",
  },
  {
    id: 2,
    name: "Gail Massie",
    initial: "G",
    location: "Magic Valley, ID",
    project: "Dirt & Gravel Delivery",
    date: "3/18/25",
    rating: 5,
    text: "Today I ordered dirt from this company! They were courteous and professional. The dirt was just what we needed. Most importantly the prices are better than others. I will be calling them again in the fall for gravel. If you need dirt or gravel these guys are the ones to call!",
  },
];

export const serviceTypes = [
  "Material Delivery",
  "Debris Removal",
  "Dump Truck Hauling",
];

export const materialClasses = [
  "Road Base",
  "Mountain Quartz",
  "3/4 Gray A",
  '"A" Rock',
  "Pea Gravel",
  "Fine sand",
  "Fill dirt",
  "Topsoil",
  "Other",
];

export const heroTruckImage =
  "https://customer-assets-lxgj4vgw.emergentagent.net/job_magic-valley-truck/artifacts/umewbnlz_Yellow%20Truck.jpeg";

export const logoImage =
  "https://customer-assets-lxgj4vgw.emergentagent.net/job_magic-valley-truck/artifacts/y8hdeipb_Front_left_Chest_option_2-removebg-preview%20%281%29.png";

export const fleetPhotos = [
  {
    id: "f1",
    title: "Ortiz Dump Truck",
    caption: "On-site material delivery",
    image:
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_magic-valley-truck/artifacts/umewbnlz_Yellow%20Truck.jpeg",
  },
  {
    id: "f2",
    title: "Delivery in Action",
    caption: "Offloading fresh material",
    image:
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_magic-valley-truck/artifacts/412oe7vb_IMG_1936.webp",
  },
  {
    id: "f3",
    title: "Job Site Crew",
    caption: "Truck & excavator combo",
    image:
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_magic-valley-truck/artifacts/iw3lwnq6_IMG_2452%20%281%29.webp",
  },
  {
    id: "f4",
    title: "Heavy Contract Hauling",
    caption: "Peterbilt & loader at the pit",
    image:
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_magic-valley-truck/artifacts/x4dhgjj3_IMG_1819.webp",
    rotate: 90,
  },
];

export const aboutImage =
  "https://customer-assets-lxgj4vgw.emergentagent.net/job_magic-valley-truck/artifacts/tugt6mko_IMG_1783.webp";
